import classnames from "classnames";
import React from "react";

import PageLink, { PageLinkProps } from "./PageLink/pageLink.component";

type Props = {
    links?: Array<PageLinkProps>;
    spread?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
};

const PageLinks = ({ links = [], spread = 1 }: Props) => {
    return (
        <div className={classnames("pl-component")}>
            {links.map(({ link, label }, index) => (
                <PageLink
                    link={link}
                    label={label}
                    spread={spread}
                    key={index}
                />
            ))}
        </div>
    );
};

export { PageLinks };
